import React from "react"
import ReactDOM from "react-dom/client"

import Main from "./pages/Main"

import "./index.css"

import "./tokens/light.variables.css"
import "./tokens/dark.variables.css"

ReactDOM.createRoot(document.getElementById("root")!).render(<Main />)
